(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clos-voucher"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accommodation-voucher')) {
  customElements.define('accommodation-voucher', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const select = this.querySelector('select[name="id"]');
      const digital = this.querySelector('[data-digital]');
      const box = this.querySelector('fieldset[data-box]');
      const giftFor = this.querySelectorAll('input[name="properties[Voucher destination]"]');
      const button = this.querySelector('button[type="submit"]');
      const guests = this.querySelector('select[data-guests]');
      const radios = this.querySelectorAll('input[name="voucher_type"]');
      const update = () => {
        const isBox = this.querySelector('input[name="voucher_type"]:checked').value === 'box';
        const option = Array.from(select.options).find(o => (o.dataset.box === 'true') === isBox && (!guests || o.dataset.guests === guests.value));
        select.value = option ? option.value : '';
        const isSelf = this.querySelector('input[name="properties[Voucher destination]"]:checked').value === 'Send to me';
        digital.hidden = isBox || isSelf;
        digital.disabled = isBox || isSelf;
        this.querySelector('[data-self-digital]').hidden = isBox || !isSelf;
        this.querySelector('[data-recipient-digital]').hidden = isBox || isSelf;
        this.querySelector('[data-self-box]').hidden = !isBox || !isSelf;
        this.querySelector('[data-recipient-box]').hidden = !isBox || isSelf;
        this.querySelector('[data-delivery-instruction]').value = isBox
          ? (isSelf ? 'Post to purchaser at checkout shipping address' : 'Post to recipient at checkout shipping address')
          : (isSelf ? 'Email to purchaser using checkout email' : 'Email to nominated recipient');
        this.querySelector('[data-box-limit]').hidden = !isBox;
        this.querySelector('[data-digital-limit]').hidden = isBox;
        box.hidden = !isBox;
        box.disabled = !isBox;
        const message = this.querySelector('textarea[name="properties[Gift message]"]');
        message.maxLength = isBox ? 20 : 200;
        message.setCustomValidity(message.value.length > message.maxLength ? message.dataset.limitError : '');
        this.querySelector('[data-message-count]').textContent = message.value.length + ' / ' + message.maxLength;
        button.disabled = !option || option.disabled;
        if(option) this.querySelector('[data-price]').textContent = option.dataset.price;
      };
      radios.forEach(radio => radio.addEventListener('change', update));
      giftFor.forEach(radio => radio.addEventListener('change', update));
      if(guests) guests.addEventListener('change', update);
      this.querySelector('textarea').addEventListener('input', update);
      update();
      const form = this.querySelector('form');
      let pending = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || !form.reportValidity() || button.disabled) return;
        pending = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const error = this.querySelector('[data-error]');
        error.textContent = '';
        const cartFeedback = window.ClosCartFeedback?.start();
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', body: new FormData(form), headers: {Accept: 'application/json'}
          });
          if (!response.ok) throw new Error('cart');
          await cartFeedback?.finish(true);
          window.location.assign(window.Shopify.routes.root + 'checkout');
        } catch {
          await cartFeedback?.finish(false);
          error.textContent = this.dataset.errorMessage;
          pending = false;
          update();
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
